import React, { useEffect, useState } from "react";
import { fetchFormEntryAssetUrl } from "../../actions/signedDownloads";

export const LocalUploadPreview = ({ upload, full = false }) => {
    const [datauri, setdatauri] = useState<string | null>(null);
    const [missing, setMissing] = useState(false);

    useEffect(() => {
        let cancelled = false;
        (async () => {
            const uuid = upload.uuid || (upload.file && upload.file.uuid);
            if (!uuid) {
                return;
            }

            let src = null;
            if (window.AssetManager && upload.file && upload.file.path) {
                src = await window.AssetManager.toBlob(upload.file).catch(() => null);
            }
            if (!src) {
                // The asset endpoint now requires auth, and an <img> can't send a
                // header — so fetch a short-lived signed URL (authed) and point
                // the image at that instead of the raw backend URL.
                src = await fetchFormEntryAssetUrl(uuid).catch(() => null);
            }

            if (!cancelled) {
                setdatauri(src);
                setMissing(!src);
            }
        })();
        return () => {
            cancelled = true;
        };
    }, [upload]);

    const width = full ? "100%" : "100px";

    if (!datauri) {
        return (
            <div
                style={{
                    width,
                    height: full ? "300px" : "100px",
                    background: "#eee",
                    color: "#888",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "12px",
                    textAlign: "center",
                }}
            >
                {missing ? "Bild nicht verfügbar" : ""}
            </div>
        );
    }

    return (
        <div>
            <img width={width} src={datauri} />
        </div>
    );
};
